// Decide where a freshly authenticated user should land based on setup state.
// Block on the fewest possible things so we don't stand between users and the app.
// - No business at all → send to workspace setup
// - Business exists but brand voice never captured → send to voice wizard
// - Otherwise → dashboard (strategy/briefs are surfaced as banners, not gates)
export function getPostLoginRoute(user) {
  const onboarding = user?.onboarding || {};
  if (!onboarding.has_business) {
    return "/settings?tab=workspace&first=1";
  }
  if (!onboarding.has_voice_profile) {
    return "/settings/personalization/voice-wizard?first=1";
  }
  return "/dashboard";
}
